<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="far fa-envelope mr-2"></i>Contacto
            </template>

            <h5 class="text-primary">Soporte técnico</h5>
            <p>
                Si experimenta cualquier problema con la plataforma puede ponerse en contacto con el departamento
                técnico en la siguiente dirección de correo electrónico: <a :href="'mailto:' + $t('error.supportmail')">
                {{ $t('error.supportmail') }}</a>.
            </p>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "ContactPage"
    };
</script>

<style scoped>

</style>